import React from "react";

export const VerifiedSvg = ({size = 20, ...props}) => {
    return (
        <svg
            width={size}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 368"
            {...props}>
            <defs>
                <clipPath id="i0">
                    <path
                        d="M251.344 1.005c10.351 3.36 16.793 14.494 23.218 25.485l.676 1.156c4.624 7.891 9.31 15.565 15.506 20.075 15.268 11.112 45.484 7.8 56.596 23.064 6.38 8.767 4.884 21.754 3.653 34.66l-.126 1.335c-.83 8.893-1.401 17.677.957 24.941 2.105 6.487 7.057 12.625 12.461 18.768l.88.996c1.03 1.162 2.072 2.326 3.11 3.492l.887 1.001c7.676 8.68 14.838 17.579 14.838 27.675 0 10.873-8.307 20.356-16.615 29.675l-.89.998-1.33 1.495-.88.997c-5.404 6.142-10.356 12.28-12.461 18.767-2.36 7.264-1.79 16.048-.96 24.941l.125 1.335.128 1.335.128 1.335c1.144 12.007 2.031 23.827-3.909 31.99-6.11 8.398-17.999 11.174-30.003 13.821l-1.31.289-1.308.289-1.307.291c-8.481 1.903-16.71 4.042-22.664 8.374-15.116 11-21.24 40.8-39.4 46.716-9.636 3.13-20.75-1.613-32.033-6.517l-1.231-.535-1.233-.534c-8.423-3.643-16.886-7.062-24.847-7.062-7.96 0-16.424 3.42-24.847 7.062l-1.233.534-1.231.535c-11.282 4.904-22.397 9.648-32.033 6.517-9.625-3.125-15.87-12.97-21.864-23.172l-.677-1.156-1.015-1.735-.677-1.155c-4.515-7.687-9.122-15.098-15.167-19.498-7.023-5.111-17.21-7.17-27.244-9.39l-1.308-.29-1.304-.295c-10.852-2.469-21.184-5.457-26.74-13.089-5.72-7.86-5.11-19.112-4.034-30.657l.125-1.333.128-1.335.128-1.335.126-1.335c.83-8.893 1.401-17.677-.957-24.94-2.105-6.488-7.057-12.626-12.461-18.768l-.88-.997-1.33-1.495-.89-.998a551.239 551.239 0 01-2.22-2.5l-.88-1.005C6.36 201.617 0 193.167 0 183.653c0-10.096 7.162-18.994 14.838-27.675l.888-1c1.037-1.167 2.079-2.33 3.11-3.493l.879-.996c5.404-6.143 10.356-12.281 12.461-18.768 2.36-7.264 1.79-16.048.96-24.941l-.125-1.335c-.107-1.112-.215-2.225-.32-3.336l-.123-1.332c-1.035-11.31-1.514-22.283 4.096-29.992 5.443-7.481 15.474-10.501 26.086-12.943l1.302-.296 1.306-.293a834.5 834.5 0 011.309-.29l1.31-.288c9.385-2.067 18.714-4.177 25.279-8.954 6.198-4.51 10.884-12.18 15.507-20.069l1.015-1.734c.338-.578.676-1.157 1.016-1.734l.68-1.153c5.79-9.78 11.92-19.009 21.182-22.026 9.986-3.244 21.56 1.969 33.264 7.052l1.233.535c8.423 3.642 16.886 7.061 24.847 7.061 7.96 0 16.424-3.419 24.847-7.061l1.233-.535c11.703-5.083 23.278-10.296 33.264-7.052z"></path>
                </clipPath>
                <clipPath id="i1">
                    <path
                        d="M126.444 0c69.833 0 126.444 56.61 126.444 126.444 0 69.833-56.61 126.444-126.444 126.444C56.611 252.888 0 196.278 0 126.444 0 56.611 56.61 0 126.444 0z"></path>
                </clipPath>
                <clipPath id="i2">
                    <path
                        d="M117.079 4.099c5.468 5.466 5.47 14.331.004 19.8l-57.6 57.6a14 14 0 01-19.784-.012l-35.6-35.6c-5.467-5.469-5.465-14.334.004-19.8 5.468-5.467 14.333-5.465 19.8.004l25.696 25.696 47.68-47.684c5.466-5.469 14.331-5.47 19.8-.004z"></path>
                </clipPath>
            </defs>
            <g clipPath="url(#i0)" transform="translate(0 .347)">
                <path
                    fill="rgba(255, 202, 58, 0.7)"
                    d="M0 -6.43929354e-15L384 -6.43929354e-15 384 367.306259 0 367.306259 0 -6.43929354e-15z"
                ></path>
            </g>
            <g
                clipPath="url(#i1)"
                transform="translate(0 .347) translate(65.556 57.21)"
            >
                <path
                    fill="#FFA93A"
                    d="M0 0L252.888 0 252.888 252.888 0 252.888 0 0z"
                ></path>
            </g>
            <g
                clipPath="url(#i2)"
                transform="translate(0 .347) translate(131.405 140.866)"
            >
                <path
                    fill="#FFFAE3"
                    d="M-7.10542736e-15 1.33226763e-14L121.181429 1.33226763e-14 121.181429 85.5867162 -7.10542736e-15 85.5867162 -7.10542736e-15 1.33226763e-14z"
                ></path>
            </g>
        </svg>
    );
}
